export const dateFormats = {
    req: "YYYY-MM-DD"
}